import { render, staticRenderFns } from "./reset.vue?vue&type=template&id=44328067&"
import script from "./reset.vue?vue&type=script&lang=js&"
export * from "./reset.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/hamzakambaza/Desktop/Sites/soirs-edu/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('44328067')) {
      api.createRecord('44328067', component.options)
    } else {
      api.reload('44328067', component.options)
    }
    module.hot.accept("./reset.vue?vue&type=template&id=44328067&", function () {
      api.rerender('44328067', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/auth/reset.vue"
export default component.exports